<template>
  <div id="return">
    <sf-heading :description="$t('Payment Return')" :level="2" :title="$t('loading')">
    </sf-heading>
    <OrkLoader :loading="true"></OrkLoader>
  </div>
</template>

<script>

import {SfHeading} from '@storefront-ui/vue';
import Api from "@/api/Api";
import OrkLoader from "@/components/Ork/OrkLoader";

export default {
  name: 'PaymentReturn',
  components: {
    OrkLoader,
    SfHeading
  },

  mounted() {
    this.submitDetails();
  },
  methods: {
    submitDetails() {
      // get query params

      const {query} = this.$route;
      const redirectResult = query.redirectResult;
      let result = {resultCode: 'NoResult'};
      if (redirectResult) {
        // submit additional details
        Api.payment.submitAdditionalDetails({details: {redirectResult}}).then((data) => {
          result = data
        })
            .catch((e) => {
            })
            .finally(() => {
              if (result.resultCode === "Authorised") {
                this.$router.push(this.$localizePath(`/commande/merci/${result.merchantReference}`)).catch();
                this.$store.dispatch('setCart', null);
              } else {
                this.$router.push(this.$localizePath("/commande/paiement/resultat?data=" + encodeURIComponent(btoa(JSON.stringify(result))))).catch();
              }
            })
      } else {
        this.$router.push(this.$localizePath("/")).catch();
      }
    }
  }
};

</script>

<style lang="scss" scoped>
#return {

}
</style>
